export const ENDPOINT_MAP = {
  // complex response
  spRetention: 'field_sp_retention',
  existingGuestRetention: 'field_existing_guest_retention',
  newGuestRetention: 'field_new_guest_retention',
  pColorTransactions: 'field_p_color_transactions',
  pRetailSales: 'field_p_retail_sales',
  pGuestsPrebooked: 'field_p_guests_prebooked',
  pGuestsPurchasing: 'field_p_guests_purchasing',
  pTreatmentTransactions: 'field_p_treatment_transactions',
  rpct: 'field_rpct',
  rprt: 'field_rprt',
  tnTransactionsBmrk: 'field_tn_transactions_bmrk',
  // short response
  tnNewGuestsServiced: 'field_tn_new_guests_serviced',
  tnGuestsServiced: 'field_tn_guests_serviced',
  tnSp: 'field_tn_sp',
  tnServiceTransactions: 'field_tn_service_transactions',
  tnTransactionsNumber: 'field_tn_transactions_number',
  tnRetailOnlyTr: 'field_tn_retail_only_tr',
  totalSales: 'field_total_sales',
} as const;

export const PLAN_PREVIOUS_DATE_RANGE_DATASET = {
  avgByClassification: {
    label: 'Average Salon (By Classification)',
  },
  lastYear: {
    label: "Last Year's Data",
  },
  previousQuarter: {
    label: "Previous Quarter's Data",
  },
} as const;

export const KPI_PLAN_TYPES = [
  { label: 'Guest', id: 'guest' },
  { label: 'Team', id: 'team' },
  { label: 'Higher Tickets', id: 'higher_tickets' },
] as const;

type PlanTypeId = (typeof KPI_PLAN_TYPES)[number]['id'];

export const RP_KPIS = ['rpct', 'rprt'] as const;

// sum should be 12
export const MD_SIZES: Record<PlanTypeId | 'rp', number> = {
  guest: 3.3,
  team: 2,
  higher_tickets: 4.4,
  rp: 2.3,
};
